import { ValueOf } from './util';

export const unusedBalanceAggregationCriterias = {
  MONTHLY: '月次',
  WALLET_SERVICE: 'ウォレットサービス別',
} as const;

export type UnusedBalanceAggregationCriteriaKey = keyof typeof unusedBalanceAggregationCriterias;
export type UnusedBalanceAggregationCriteriaValue = ValueOf<typeof unusedBalanceAggregationCriterias>;

export const unusedBalanceAggregationCriteriaKeys = Object
  .keys(unusedBalanceAggregationCriterias) as UnusedBalanceAggregationCriteriaKey[];

/** v-select用items */
export const unusedBalanceAggregationCriteriaItems = unusedBalanceAggregationCriteriaKeys
  .map((key) => ({
    title: unusedBalanceAggregationCriterias[key],
    value: key,
  }));
